import axios, { widgetAxios } from './axios';

import {
  LocationGroupResponseTypes,
  ProjectCooperatorsResponseTypes,
  ProjectResponseTypes,
  ResponseTypes,
  TemplateCategoryResponseTypes,
} from '../types/response';
import {
  GET_ORGANIZATIONS_DETAIL_API,
  GET_PROJECT_API,
  GET_PAGE_LAYOUT_DATA,
  GET_TEMPLATE,
} from '../commons/constants/apis';
import { PageLayoutType, TemplateType } from '../types/pageLayout.type';

export const authorizeProject = async (
  key: string,
  token: string,
  language: string
): Promise<any> => {
  try {
    const resp: ResponseTypes<ProjectResponseTypes> = await axios.get(
      `${GET_PROJECT_API}/${key}/authorize?token=${token}`,
      { headers: { language } }
    );

    return resp.data;
  } catch (e) {
    return { notFound: true, invalid: undefined };
  }
};

export const getProjectByKey = async (key: string, language: string): Promise<any> => {
  try {
    const resp: ResponseTypes<ProjectResponseTypes> = await axios.get(`${GET_PROJECT_API}/${key}`, {
      headers: { language },
    });

    return resp.data;
  } catch (e) {
    return { notFound: true };
  }
};

export const getProjectLocationGroups = async (key: string, language: string): Promise<any> => {
  try {
    const resp: ResponseTypes<LocationGroupResponseTypes[]> = await axios.get(
      `${GET_PROJECT_API}/${key}/location-groups`,
      {
        headers: { language },
      }
    );

    return resp.data;
  } catch (e) {
    return null;
  }
};

export const getProjectTemplateCategories = async (key: string, language: string): Promise<any> => {
  try {
    const resp: ResponseTypes<TemplateCategoryResponseTypes[]> = await axios.get(
      `${GET_PROJECT_API}/${key}/template-categories`,
      {
        headers: { language },
      }
    );

    return resp.data;
  } catch (e) {
    return null;
  }
};

export const getCooperatorDetailByCode = async (code: string, language: string): Promise<any> => {
  try {
    const resp: ResponseTypes<ProjectCooperatorsResponseTypes> = await axios.get(
      `${GET_ORGANIZATIONS_DETAIL_API}/${code}`,
      {
        headers: { language },
      }
    );
    return resp.data;
  } catch (e) {
    return null;
  }
};

export const getDataPageLayout = async (token: string): Promise<PageLayoutType> => {
  try {
    const res: ResponseTypes<PageLayoutType> = await axios.get(`${GET_PAGE_LAYOUT_DATA}/${token}`);
    return res.data;
  } catch (err) {
    return null;
  }
};

export const getWidgetTemplate = async (token: string, language: string): Promise<TemplateType> => {
  try {
    const res = await widgetAxios.get(`${GET_TEMPLATE}?token=${token}`, { headers: { language } });
    return res.data;
  } catch (e) {
    return null;
  }
};

export const getReviewsByCode = async (code: string, language: string): Promise<any> => {
  try {
    const { data }: ResponseTypes<ProjectResponseTypes> = await axios.get(
      `${GET_PROJECT_API}/${code}/reviews`,
      { headers: { language } }
    );

    return data;
  } catch (e) {
    return { notFound: true };
  }
};
